import { useAccordion } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import { offerType, tabType } from '../constants';
const legalDisclaimerByPaymentTab = {
    [tabType.rebate]: 'Pages.SpecialOffers.rebateDisclaimerText',
    [tabType.finance]: 'Pages.SpecialOffers.financeDisclaimerText',
    [tabType.lease]: 'Pages.SpecialOffers.leaseDisclaimerText',
};
const offerLegalDisclaimer = {
    [offerType.customerIncentiveDollars]: 'Shared.Common.cidDisclaimerText',
    [offerType.customerCashRebate]: 'Shared.Common.ccrDisclaimerText',
    [offerType.tradingDollars]: 'Shared.Common.tdDisclaimerText',
    [offerType.afsLoyaltyDollars]: 'Shared.Common.afsLdDisclaimerText',
    [offerType.cashOrMaintenancePackage]: 'Shared.Common.cashOrMaintDisclaimerText',
    [offerType.crmDollars]: 'Shared.Common.crmdDisclaimerText',
    [offerType.leaseBonus]: 'Shared.Common.leaseBonusDisclaimerText',
    [offerType.financeBonus]: 'Shared.Common.financeBonusDisclaimerText',
    [offerType.specialSalesEvent]: 'Shared.Common.spSalesEventDisclaimerText',
    [offerType.nonStackableTradingDollar]: 'Shared.Common.nstdDisclaimerText',
    [offerType.leaseNSTD]: 'Shared.Common.leaseNstdDisclaimerText',
    [offerType.financeNSTD]: 'Shared.Common.financeNstdDisclaimerText',
};
const useLegalAccordion = ({ activePaymentTab, additionalRebate = false, offers, }) => {
    const { t } = useTranslation();
    const disclaimers = [
        // lease or finance tab could have additional rebate/cash disclaimer
        ...(additionalRebate ? [legalDisclaimerByPaymentTab[tabType.rebate]] : []),
        ...offers.map(offer => offer.disclaimer || offerLegalDisclaimer[offer.name]),
    ];
    const legalDisclaimer = {
        key: `${activePaymentTab}-legal-disclaimer`,
        title: t('Pages.SpecialOffers.viewFullLegalButton'),
        contents: disclaimers.map((disclaimer, index) => ({
            key: disclaimer,
            text: t(disclaimer),
            order: index + 1,
        })),
    };
    const accordionBehaviour = useAccordion([legalDisclaimer]);
    const { expandAllItems, collapseAllItems } = accordionBehaviour;
    return {
        legalDisclaimer,
        accordionBehaviour,
        openAccordion: () => {
            expandAllItems();
        },
        closeAccordion: () => {
            collapseAllItems();
        },
    };
};
export default useLegalAccordion;
